import { createStyleSheet } from '@shared-ui/theme'
import { rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  row: { alignItems: 'center', flexDirection: 'row' },
  icon: {
    borderColor: theme.COLOR_BG_BASE,
    borderRadius: rw(10),
    borderWidth: rw(1.5),
    height: rw(20),
    width: rw(20),
  },
  overlap: { marginLeft: rw(-4) },
}))
